export default (axios, alert) => ({
  /**
   * Tarife des Kunden. Kommen nicht mit dem Status mit, solange
   * CREDITLIFE_TARIFE_IM_STATUS im CRM aus ist – dann holt sie der Block
   * selbst, sobald er angezeigt wird. Antwort: { success, data: { produkt,
   * testmodus, tarife, leistungen, dokumente, dokumente_version, gueltig_bis } }
   */
  tarife () {
    return axios.get('/customer/creditlife/tarife').then(({ data }) => data)
  },

  /**
   * Tarife fuer die Design-Vorschau (/creditlife-vorschau). Laeuft ohne Login,
   * deshalb wird der Bearer aus `creditlife_demo_token` explizit gesetzt statt
   * vom Auth-Modul. Antwort hat dieselbe Form wie `tarife()`.
   */
  demoTarife () {
    const token = process.env.creditlife_demo_token

    return axios.get('/creditlife/demo/tarife', {
      headers: token ? { Authorization: `Bearer ${token}` } : {}
    }).then(({ data }) => data)
  },

  /**
   * Abschluss. Stammdaten liegen im CRM, der Kunde schickt nur seine
   * Tarifwahl und die Zustimmungen zurueck.
   */
  abschluss (form) {
    return axios.post('/customer/creditlife/abschluss', form).then(({ data }) => data)
  }
})
